import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { SlideHeadline } from '../SlideHeadline';
import { CtaGlyph } from '../CtaGlyph';
import { EmbeddedSnakWindow } from '../EmbeddedSnakWindow';
import { actionCtas, clinicalCasesSnakUrl, orderPageScreenshot, orderPageUrl, proceduresPdfUrl, screenshots } from '../../../data/deck';
export function FeedbackSlide() {
  const [casesOpen, setCasesOpen] = useState(false);
  const [proceduresOpen, setProceduresOpen] = useState(false);
  const [orderOpen, setOrderOpen] = useState(false);
  return <Slide id="feedback" data-id="element-267" data-mp="1namxb9vpmkka">
      <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1fr)_auto] lg:gap-20" data-id="element-268" data-mp="1s9zf3g7q51g0">
        <div className="max-w-[620px]" data-id="element-269" data-mp="bvpsaqj4rkra">
          <InView data-id="element-270" data-mp="buofohmguq7g">
            <SlideHeadline lead="You liked the family." follow="Let's put it to work." data-id="element-271" data-mp="bu4yj34n45uh" />
          </InView>
          <InView delay={0.1} data-id="element-272" data-mp="gw42of87f6sh">
            <p className="mt-8 max-w-[40ch] font-heading text-[19px] leading-[1.35] text-[rgba(1,51,43,0.62)]" data-id="element-273" data-mp="2zvhb0ddhv393">
              The creative concept caught your attention. Your feedback was clear: make it
              more actionable.
            </p>
          </InView>

          <InView delay={0.18} className="mt-12" data-id="element-274" data-mp="39uyf4qd3l92y">
            <p className="font-body text-[10px] uppercase tracking-[0.22em] text-[rgba(1,51,43,0.45)]" data-id="element-275" data-mp="34u0w6bk9kb0e">
              What if every family member could guide dentists directly to
            </p>
            <ul className="mt-5 grid gap-x-8 sm:grid-cols-2" data-id="element-276" data-mp="3et9mmufx77i0">
              {actionCtas.map(cta => <li key={cta.icon} className="flex items-center gap-3.5 border-t border-[rgba(1,51,43,0.12)] py-4" data-id="element-277" data-mp="3sko9jccy7suc">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background text-primary" data-id="element-278" data-mp="6cy1aukv29hf">
                    <CtaGlyph icon={cta.icon} size={18} data-id="element-279" data-mp="1emr2iqnlwyo" />
                  </span>
                  <span className="font-body text-[14.5px] leading-snug text-background" data-id="element-280" data-mp="8hbj2rhu0t71">
                    {cta.label}
                  </span>
                </li>)}
            </ul>
          </InView>

          <InView delay={0.26} data-id="element-281" data-mp="iexxzdz4skr0">
            <p className="mt-10 flex items-center gap-3 font-body text-[13px] text-[rgba(1,51,43,0.6)]" data-id="element-282" data-mp="idmyhqcpxz5p">
              <span aria-hidden="true" className="h-[2px] w-8 rounded-full bg-primary" data-id="element-283" data-mp="n7908nhcgimq" />
              From a memorable introduction to a meaningful next step.
            </p>
          </InView>
        </div>

        <InView delay={0.12} y={28} className="relative flex justify-center lg:justify-end" data-id="element-284" data-mp="w8pb0wc2mmrh">
          <figure className="relative" data-id="element-285" data-mp="116ic5ayioqkw">
            <img src={screenshots.easyMatchCtas} alt="Updated Filtek Easy Match screen in the Snak, with four CTA buttons: see clinical cases, explore procedures, try the product and order or find a supplier" className="block h-[min(88vh,900px)] min-h-[560px] w-auto mix-blend-multiply" data-id="element-286" data-mp="164k0obeppi3r" />
            <button type="button" onClick={() => setCasesOpen(true)} aria-label="See clinical cases — open the clinical cases Snak" className="group absolute rounded-[10px] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" style={{
            left: '13.6%',
            top: '74.4%',
            width: '35%',
            height: '5.8%'
          }} data-id="element-287" data-mp="30e786lmsrg6q">
              <motion.span aria-hidden="true" className="absolute inset-0 rounded-[10px] ring-2 ring-primary" animate={{
              opacity: [0.9, 0.15, 0.9],
              scale: [1, 1.04, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2,
              ease: 'easeInOut'
            }} data-id="element-288" data-mp="3jb012gs1yf0j" />
            </button>
            <button type="button" onClick={() => setProceduresOpen(true)} aria-label="Explore procedures — open the Filtek Matrix step-by-step protocol" className="group absolute z-10 rounded-[10px] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" style={{
            left: '50.1%',
            top: '74.4%',
            width: '34.8%',
            height: '5.8%'
          }} data-id="element-289" data-mp="34gltrdhuou1p">
              <motion.span aria-hidden="true" className="absolute inset-0 rounded-[10px] ring-2 ring-primary" animate={{
              opacity: [0.9, 0.15, 0.9],
              scale: [1, 1.04, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2,
              delay: 0.5,
              ease: 'easeInOut'
            }} data-id="element-290" data-mp="37vlxhuv56amf" />
            </button>
            <button type="button" onClick={() => setOrderOpen(true)} aria-label="Order or find a supplier — open the Filtek composites page" className="group absolute z-10 rounded-[10px] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" style={{
            left: '50.1%',
            top: '80.8%',
            width: '34.8%',
            height: '5.8%'
          }} data-id="element-291" data-mp="9cortse6lxd3">
              <motion.span aria-hidden="true" className="absolute inset-0 rounded-[10px] ring-2 ring-primary" animate={{
              opacity: [0.9, 0.15, 0.9],
              scale: [1, 1.04, 1]
            }} transition={{
              repeat: Infinity,
              duration: 2,
              delay: 1,
              ease: 'easeInOut'
            }} data-id="element-292" data-mp="2k3evaf2qj9f3" />
            </button>
            <figcaption className="absolute right-[96%] top-[76%] hidden w-[190px] items-center gap-3 xl:flex" data-id="element-293" data-mp="176psla7dklst">
              <span className="text-right font-body text-[11px] uppercase leading-snug tracking-[0.16em] text-background" data-id="element-294" data-mp="jig769e2q027">
                New · Four professional next steps
              </span>
              <span aria-hidden="true" className="h-px w-10 shrink-0 bg-background" data-id="element-295" data-mp="saqk3ygcsjn5" />
            </figcaption>
          </figure>
        </InView>
      </div>

      <AnimatePresence data-id="element-296" data-mp="3vys9a0jpfld0">
        {casesOpen && <EmbeddedSnakWindow key="cases" url={clinicalCasesSnakUrl} title="Clinical cases Snak" onClose={() => setCasesOpen(false)} data-id="element-297" data-mp="3vxh5w1u68fmf" />}
        {orderOpen && <EmbeddedSnakWindow key="order" url={orderPageUrl} title="Solventum composites" shape="browser" content={<div className="no-scrollbar h-full w-full overflow-y-auto bg-white" data-id="element-299" data-mp="24mvtzopb74ju">
                <img src={orderPageScreenshot} alt="Solventum website: All composites product listing, including Filtek Easy Match Flowable Restorative and Filtek Composite Warmer parts" className="block w-full" data-id="element-300" data-mp="29kf9erxqtndd" />
              </div>} onClose={() => setOrderOpen(false)} data-id="element-298" data-mp="1uuhpwpardlui" />}
        {proceduresOpen && <EmbeddedSnakWindow key="procedures" url={proceduresPdfUrl} title="Filtek Matrix · Step-by-step protocol" shape="document" onClose={() => setProceduresOpen(false)} data-id="element-301" data-mp="1qwjzxk95yvq2" />}
      </AnimatePresence>
    </Slide>;
}